<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <fiscal-years-select
            :fiscalYears="form.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />

        <!-- SUBMIT -->
        <div class="aright mt-5">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="close"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                @click="submitForm"
            />
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    mixins: [SettingsFormMixin],
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
    components: {
        'fiscal-years-select': FiscalYearsSelect,
    },
};
</script>
